import React from "react";
import PropTypes from "prop-types";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

export const DraggableVirtualTag = ({ row, index = 0, isLastRow = false, selectVirtualTag }) => {
    const {
        attributes,
        listeners,
        transform,
        transition,
        setNodeRef,
        isDragging
    } = useSortable({
        id: row.original.id
    });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition: transition,
        display: isDragging ? 'none' : undefined,
    };

    // Extract key from row props to avoid spreading it
    const { key, ...rowProps } = row.getRowProps();

    return (
        <div
            key={key}
            ref={setNodeRef}
            style={style}
            {...rowProps}
            className={`tr group rounded-[11px] transition-colors hover:bg-[#EAEEF5] cursor-pointer ${
                index % 2 === 1 ? 'bg-[#F7F9FC]' : ''
            } ${isLastRow ? '' : 'mb-[3px]'}`}
            onClick={() => selectVirtualTag(row.original)}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    selectVirtualTag(row.original);
                }
            }}
            tabIndex={0}
            role="button"
            aria-label={`Select virtual tag ${row.original.name}`}
        >
            {row.cells.map((cell, cellIndex) => {
                const { key, ...cellProps } = cell.getCellProps();
                const centered = cell.column.align === "center";
                return (
                    <div
                        key={key}
                        {...cellProps}
                        className={`td flex items-center py-2.5 text-sm ${
                            centered ? 'justify-center' : cellIndex === 0 ? 'pl-5' : 'pl-2'
                        }`}
                    >
                        {cellIndex === 0 ? (
                            <div className="flex items-center min-w-0">
                                <div
                                    {...attributes}
                                    {...listeners}
                                    className="cursor-grab mr-2 shrink-0 text-text-3 hover:text-text"
                                >
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
                                        <circle cx="2" cy="2" r="1"/>
                                        <circle cx="6" cy="2" r="1"/>
                                        <circle cx="10" cy="2" r="1"/>
                                        <circle cx="2" cy="6" r="1"/>
                                        <circle cx="6" cy="6" r="1"/>
                                        <circle cx="10" cy="6" r="1"/>
                                        <circle cx="2" cy="10" r="1"/>
                                        <circle cx="6" cy="10" r="1"/>
                                        <circle cx="10" cy="10" r="1"/>
                                    </svg>
                                </div>
                                {cell.render("Cell")}
                            </div>
                        ) : (
                            cell.render("Cell")
                        )}
                    </div>
                );
            })}
        </div>
    );
};

DraggableVirtualTag.propTypes = {
    row: PropTypes.object.isRequired,
    index: PropTypes.number,
    isLastRow: PropTypes.bool,
    selectVirtualTag: PropTypes.func.isRequired,
};
